export default {
    statusActions: {
        validate: 'Validiraj',
        approve: 'Odobri',
        revertToDraft: 'Vrni v osnutek',
        lock: 'Zakleni',
        unlock: 'Odkleni',
        statusChangedTitle: 'Status → {target}',
        transitionRejectedTitle: 'Prehod zavrnjen',
        transitionRejectedMessage: 'prehod zavrnjen',
        transitionFailedMessage: 'prehod ni uspel',
    },
}
